import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {
    CasinoGame,
    ListCasinoGameResponse, MonetaryConfig, MonetaryConfigListResponse,
    TurnoverContributions,
    TurnoverContributionsListResponse
} from "../http/protocol";


export class MonetaryConfigService  extends AbstractAdminEntityService<MonetaryConfig, MonetaryConfigListResponse>  {

    constructor(http : HttpService) {
        super("/bonus/monetary-config", http)
    }

}